import {
  inScopeModuleNodeSelector,
  inScopeNodesSelector,
  inScopeServiceNodesSelector,
  inScopeServicesNodesSelector,
  inScopeTopicNodesSelector,
  inScopeTopicsNodesSelector,
  inScopeVariableNodesSelector,
  inScopeVariablesNodesSelector,
} from "../nodes/querySelectors/index.ts";
import { useNautilusSelector } from "../state/shared.ts";

export const useInScopeNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeNodesSelector(state, { nodeId }));

export const useInScopeModuleNode = (nodeId: number) =>
  useNautilusSelector((state) => inScopeModuleNodeSelector(state, { nodeId }));

export const useInScopeVariableNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeVariableNodesSelector(state, { nodeId }));

export const useInScopeVariablesNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeVariablesNodesSelector(state, { nodeId }));

export const useInScopeServiceNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeServiceNodesSelector(state, { nodeId }));

export const useInScopeServicesNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeServicesNodesSelector(state, { nodeId }));

export const useInScopeTopicNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeTopicNodesSelector(state, { nodeId }));

export const useInScopeTopicsNodes = (nodeId: number) =>
  useNautilusSelector((state) => inScopeTopicsNodesSelector(state, { nodeId }));
